import { SquareArrowOutUpRightIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import { selectAccountSlug } from '@/redux/session/selectors';
import type { ContactMemory, MemoryCategory } from '@/shared/types/contacts';
import { timeFromNowShort } from '@/util/dateUtils';

interface ProfileMemoryCardProps {
  memory: ContactMemory;
}

const categoryLabelKey: Record<MemoryCategory, string> = {
  fact: 'contacts.fact',
  preference: 'contacts.preference',
};

export const ProfileMemoryCard = ({ memory }: ProfileMemoryCardProps) => {
  const { t } = useTranslation();
  const slug = useSelector(selectAccountSlug);

  const sessionUrl =
    slug && memory.session_id
      ? `/${slug}/analytics/account-chat-logs?session_id=${memory.session_id}`
      : null;

  return (
    <div className="flex w-full flex-col gap-1 pb-4">
      <span className="text-sm font-semibold text-ai">{t(categoryLabelKey[memory.category])}</span>
      <h3 className="text-sm leading-6 font-semibold text-foreground">{memory.content}</h3>
      <div className="mt-2 flex items-center justify-between gap-3">
        {sessionUrl ? (
          <Link
            to={sessionUrl}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-foreground"
          >
            {t('contacts.view')}
            <SquareArrowOutUpRightIcon size={16} />
          </Link>
        ) : (
          <span />
        )}
        <span className="text-sm text-muted-foreground">{timeFromNowShort(memory.updated)}</span>
      </div>
    </div>
  );
};
